<div *ngIf="isLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>



<div class="container px-4 py-10 mx-auto">
  <div *ngIf="!isLoading && object" class="bg-white rounded-md">
    <p-card>
      <div class="w-full p-7">
        <ng-template pTemplate="header">
          <h2 class="text-2xl font-bold">Asset Details</h2>
        </ng-template>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label
            for="status"
            class="block mb-1 font-medium"
            >Name</label
          >

          <input p-inputText id="status" [(ngModel)]="object.name" type="text" />
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label
            for="status"
            class="block mb-1 font-medium"
            >Label</label
          >

          <input p-inputText id="status" [(ngModel)]="object.integration!.name" type="text" />
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label
            for="status"
            class="block mb-1 font-medium"
            >Status</label
          >

          <input p-inputText id="status" [(ngModel)]="object.integration!.status" type="text" />
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label
            for="status"
            class="block mb-1 font-medium"
            >Dying Gasp</label
          >

          <input p-inputText id="status" [(ngModel)]="object.integration!.dyingGasp" type="text" />
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label
            for="status"
            class="block mb-1 font-medium"
            >Distance</label
          >

          <input p-inputText id="status" [(ngModel)]="object.integration!.distance" type="text" />
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label
            for="status"
            class="block mb-1 font-medium"
            >Uptime</label
          >

          <input p-inputText id="status" [(ngModel)]="object.integration!.uptime" type="text" />
        </div>

        <ng-template pTemplate="footer">
          <button
          pButton
          label="Back to List"
          icon="pi pi-arrow-left"
          class="p-button-secondary"
          routerLink="/assets/list"
        ></button>
        </ng-template>
      </div>
    </p-card>
  </div>
</div>
